import { render, staticRenderFns } from "./CrmUserSkills.vue?vue&type=template&id=0d9d5d76&"
import script from "./CrmUserSkills.vue?vue&type=script&lang=js&"
export * from "./CrmUserSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports